import { render, staticRenderFns } from "./BundleDiscountSection.vue?vue&type=template&id=7cdfb43e&scoped=true&"
import script from "./BundleDiscountSection.vue?vue&type=script&lang=ts&"
export * from "./BundleDiscountSection.vue?vue&type=script&lang=ts&"
import style0 from "./BundleDiscountSection.vue?vue&type=style&index=0&id=7cdfb43e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdfb43e",
  null
  
)

export default component.exports